'use strict';

module.exports = {
    apiBase: 'https://order.emofa.ch/api'
};



// WEBPACK FOOTER //
// ./client/src/app/config.js